import * as React from 'react';

import { signInHeaderStyle } from '../../pages/signin/styles';
import { h2Style, pSubtitle } from '../../pages/styles';

type HeaderProps = {
  text1: string;
  text2: string;
};

export const Header = (props: HeaderProps) => {
  return (
    <div style={signInHeaderStyle}>
      <h2 style={{ ...h2Style, margin: 0 }}>{props.text1}</h2>
      <p style={{ ...pSubtitle, margin: 0 }}>{props.text2}</p>
    </div>
  );
};
